export default __webpack_public_path__ + "static/media/jiologoenterprise.6e4feca2.svg";